import { PaymentControllerStore } from '@/hooks/use-payment-controller/store'

//fields
export const isDetailOpenSelector = (state: PaymentControllerStore) =>
  state.isDetailOpen
export const autoFocusDiscountSelector = (state: PaymentControllerStore) =>
  state.autoFocusDiscount

//sets
export const setAutoFocusDiscountSelector = (state: PaymentControllerStore) =>
  state.setAutoFocusDiscount
export const setDetailOpenSelector = (state: PaymentControllerStore) =>
  state.setDetailOpen
export const resetSelector = (state: PaymentControllerStore) => state.reset
